
// import { Dropdown, Image, Typography, Menu, Avatar, Tooltip } from 'antd'
// import React, { useState } from 'react'
// import { MdCastConnected, MdMoreVert } from 'react-icons/md'
// import { FaGraduationCap } from 'react-icons/fa'
// import { ClockCircleFilled, LoadingOutlined, UserOutlined } from '@ant-design/icons'
// import { useHistory } from 'react-router-dom'
// import { connect } from 'react-redux'
// import { Api, Notification } from 'services'
// import { setStreamId } from 'actions/broadcast'
// import { joinClass, setBroadcastSelectedClassroom, setJoinLoader, fetchStudentListData, setCardData, setSelectedId, setLiveStreamUrl } from 'actions/schedule'
// import { SquareSubIcon } from 'components/subIcon'
// import { IoMdChatbubbles, IoMdVideocam } from 'react-icons/io'
// import { RiWirelessChargingLine } from 'react-icons/ri'
// import moment from 'moment'
// import Conference from "Assets/schedule/confrence.svg"
// import Broadcast from "Assets/schedule/Broadcast.svg"
// import Offline from "Assets/schedule/ofline.svg"
// import { handleJoinClass } from './handleJoinClass'
// import { EventRegister } from 'react-native-event-listeners'
// import { EmbedModal, regexMeet } from './onGoingClassCard'
// import { postEmbedLink } from 'actions/broadcast'
// import OtherColor from "Assets/schedule/other_color.svg"
// import { Button } from 'components/Button'

// const { Text } = Typography
// const OnGoingClassTandS = ({ user, onGoingItem, setStreamId, joinClass, setBroadcastSelectedClassroom, setJoinLoader, isJoinLoader, 
//     fetchStudentListData, setCardData, setSelectedId, postEmbedLink, setLiveStreamUrl }) => {
//     const history = useHistory()
//     const handleContact = () => {
//         history.push("/care/chat")
//     }
//     const [embedModalVisible, setEmbedModalVisible] = useState(false);
//     const [embedding, setEmbedding] = useState(false);
//     const [hoveringMode, setHoveringMode] = useState(false);

//     const playStream = () => {
//         if (onGoingItem.sUrl.match(regexMeet)){
//             window.open(onGoingItem.sUrl, '_blank');
//         }else{
//             setLiveStreamUrl(onGoingItem.sUrl)
//             history.push('/liveplayer')
//         }
//     }


//     const onEmbed = async(link) => {
//       setEmbedding(true);
//       await postEmbedLink({id:onGoingItem.id, sUrl: link})
//       setEmbedding(false);
//       setEmbedModalVisible(false);
//       EventRegister.emit('apicall:scheduleHome');
//     }
//     const markAttendanceHandler = () => {
//         setSelectedId(onGoingItem?.id)
//         setCardData(onGoingItem)
//         fetchStudentListData()
//         history.push('/schedule-attendance')

//     }

//     const handleJoin = async () => {
//         setJoinLoader(true);
//         setCardData(onGoingItem);
//         if (onGoingItem?.mode == "Broadcast") {
//             let currentTime = new Date();
//             if (onGoingItem.endTime){
//                 // Parse end time
//                 const [hours, minutes, seconds] = onGoingItem.endTime.split(':').map(Number);
//                 let endDateTime = new Date();
//                 endDateTime.setHours(hours, minutes, 60, 0);

//                 // Calculate the difference in milliseconds
//                 let differenceInMilliseconds = endDateTime - currentTime;
//                 let differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);
//                 if (differenceInSeconds<0){
//                     Notification.error("Error", "Class end time has passed")
//                     setJoinLoader(false)
//                     return
//                 }
//             }
//             setStreamId(onGoingItem?.roomName != null ? onGoingItem.roomName : '1234')
//             setBroadcastSelectedClassroom(onGoingItem)
//             await joinClass(onGoingItem.id, () => setJoinLoader(false));
//             history.push('/broadcast')
//         }
//         else if (onGoingItem?.mode == "Zoom 40") {
//             await joinClass(onGoingItem.id)
//             setJoinLoader(false)
//             // history.push('/zoom')
//             Notification.error("Error", "Zoom is not supported on web presently. Please join the class from the mobile.")
//         } else if (onGoingItem?.mode == "Conference" || onGoingItem?.mode == "Offline") {
//             setJoinLoader(false)
//             Notification.error("Error", "This mode is not supported on web presently")
//         } else if (onGoingItem?.mode === "Others" || onGoingItem?.mode === "Other") {
//             setJoinLoader(false);
//             setEmbedModalVisible(true);
//         }

//     }
//     const menu = (
//         <Menu style={{ width: "230px", background: "#FFFFFF", boxShadow: "8px 8px 18px #302A5F14", borderRadius: "8px" }}>
//             {
//                 user.access.includes("schedule-teacher") && user.id === onGoingItem.teacherId ?
//                 <>
//                 <Menu.Item key="2" onClick={()=>{setEmbedModalVisible(true)}}>
//                     {onGoingItem.sUrl!=undefined?'Replace link':'Add link'} 
//                 </Menu.Item>
//                 {onGoingItem?.sUrl != undefined ?
//                 <Menu.Item key="3" onClick={()=>{playStream()}}>
//                     Play stream
//                 </Menu.Item>
//                 :null}
//                 </>
//             :null}
//         </Menu>

//     );
//     if (user.access.includes("schedule-teacher")) {
//         return (
//             <div className="OnGoingClassTandS">
//                 <div style={{ display: 'flex', flexDirection: 'row' }}>
//                     <div className="ongoingclass-img-text">
//                         <div>
//                             <SquareSubIcon icon={onGoingItem?.subject?.icon ? onGoingItem?.subject?.icon : ''} name={onGoingItem?.subject?.name ? onGoingItem?.subject?.name : ''} size={40} />

//                         </div>
//                         <div style={{ marginLeft: '10px', display: 'flex', flexDirection: 'column', width: '200px' }}>
//                             {(onGoingItem.mode == "Zoom 40") ? (
//                                 <div style={{ width: '75px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E7F3FF', borderRadius: '8px', padding: '2px' }}>
//                                     <IoMdVideocam style={{ color: '#1089FF' }} />
//                                     <Text style={{ fontSize: '10px', color: '#1089FF', marginLeft: '5px' }}>Zoom 40</Text>
//                                 </div>
//                                 ) : (onGoingItem.mode == "Broadcast") ? (
//                                     <div style={{ width: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFF4D5', borderRadius: '8px', padding: '2px' }}>
//                                         <img src={Broadcast} style={{ color: '#FFA931', textAlign: 'center', height: "18px", width: "18px" }} />
//                                         <Text style={{ fontSize: '10px', color: '#FFA931', marginLeft: '5px' }}>Broadcast</Text>
//                                     </div>
//                                     ) : (onGoingItem.mode == "Conference") ? (
//                                         <div style={{ width: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F6F4FE', borderRadius: '8px', padding: '2px' }}>
//                                             <img src={Conference} style={{ color: '#594099', height: "18px", width: "18px" }} />
//                                             <Text style={{ color: '#594099', marginLeft: '5px', fontSize: '10px' }}>Conference</Text>
//                                         </div>
//                                         ) : (onGoingItem.mode == 'Others') ? (
//                                         <div onMouseEnter={() => setHoveringMode(true)} onMouseLeave={() => setHoveringMode(false)}>
//                                             {hoveringMode ? (
//                                                 <Dropdown overlay={
//                                                     <Menu>
//                                                         <Menu.Item key="1" onClick={() => setEmbedModalVisible(true)}>{onGoingItem?.sUrl ? 'Replace link' : 'Add link'}</Menu.Item>
//                                                         {onGoingItem?.sUrl ? <Menu.Item key="2" onClick={() => playStream()}>Play stream</Menu.Item> : null}
//                                                     </Menu>
//                                                 } placement="bottomRight">
//                                                     <MdMoreVert style={{ width: 18, height: 18, color: '#AEAEAE', cursor: 'pointer' }} />
//                                                 </Dropdown>
//                                             ) : (
//                                                 <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFE5F4', borderRadius: '8px', padding: '3px 7px' }}>
//                                                     <img src={OtherColor} style={{ color: '#E50087',height:"16px",width:"16px" }} />
//                                                     <Text style={{ color: '#E50087', marginLeft: '5px', fontSize: '10px' }}>Other</Text>
//                                                 </div>
//                                             )}
//                                         </div>
//                                         ) : (
//                                         <div onMouseEnter={() => setHoveringMode(true)} onMouseLeave={() => setHoveringMode(false)}>
//                                             {hoveringMode ? (
//                                                 <Dropdown overlay={
//                                                     <Menu>
//                                                         <Menu.Item key="1" onClick={() => setEmbedModalVisible(true)}>{onGoingItem?.sUrl ? 'Replace link' : 'Add link'}</Menu.Item>
//                                                         {onGoingItem?.sUrl ? <Menu.Item key="2" onClick={() => playStream()}>Play stream</Menu.Item> : null}
//                                                     </Menu>
//                                                 } placement="bottomRight">
//                                                     <MdMoreVert style={{ width: 18, height: 18, color: '#AEAEAE', cursor: 'pointer' }} />
//                                                 </Dropdown>
//                                             ) : (
//                                                 <div style={{ width: '80px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E9FCF5', borderRadius: '8px', padding: '2px' }}>
//                                                     <img src={Offline} style={{ color: '#28DF99', textAlign: 'center', height: "18px", width: "18px" }} />
//                                                     <Text style={{ fontSize: '10px', color: '#28DF99', marginLeft: '5px' }}>Offline</Text>
//                                                 </div>
//                                             )}
//                                         </div>
//                             )}
//                             <Tooltip title={onGoingItem?.subject?.name ? onGoingItem?.subject?.name : null}>
//                                 <Text style={{ fontWeight: 'bold', fontSize: '15px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{onGoingItem?.subject?.name}</Text>
//                             </Tooltip>
//                         </div>
//                     </div>
//                     {!user.privilage.includes('Institute Support') && (onGoingItem.mode==='Others' || onGoingItem.mode==='Offline') ?
//                         <div>
//                             <Dropdown overlay={menu} disabled={false} placement="bottomRight" >
//                                 <MdMoreVert style={{ width: "24px", height: "24px", color: "#AEAEAE" }} />
//                             </Dropdown>
//                         </div> : null}
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
//                     <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                         <Tooltip title={onGoingItem?.standards.length != 0 ? onGoingItem?.standards?.map((item, index, array) => (`${item?.std + "-" + item?.section}${index === array.length - 1 ? '' : ' | '}`)) : null}>
//                             <FaGraduationCap style={{ color: 'purple', marginRight: '5px' }} />
//                         </Tooltip>
//                         {onGoingItem?.standards.length != 0 ? onGoingItem?.standards?.map((item, index, array) => (
//                             <Text style={{ fontSize: '80%', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} key={index}>{item?.std + "-" + item?.section}{index === array.length - 1 ? '' : '|'}</Text>
//                         )) : null}
//                     </div>
//                     {/* <div>
//                         <Avatar
//                             style={{ backgroundColor: '#594099' }}
//                             size={14}
//                             icon={<UserOutlined />}
//                         />
//                         <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>25 Online</Text>
//                     </div> */}
//                     <div style={{ width: '50%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
//                         <Tooltip title={`${moment(onGoingItem?.startTime, 'HH:mm:ss').format("hh:mm A")}-${moment(onGoingItem?.endTime, 'HH:mm:ss').format("hh:mm A")}`}>
//                             <ClockCircleFilled style={{ fontSize: '11px', color: '#594099' }} />
//                         </Tooltip>
//                         <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{`${moment(onGoingItem?.startTime, 'HH:mm:ss').format("hh:mm A")}-${moment(onGoingItem?.endTime, 'HH:mm:ss').format("hh:mm A")}`}</Text>
//                     </div>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
//                     {(onGoingItem?.mode || '').toLowerCase() === 'broadcast' ? (
//                         <div>
//                             <Button type='primary' style={{ width: '190px', borderRadius: '8px' }}
//                                 onClick={() => handleJoin()}
//                                 disabled={isJoinLoader}
//                                 loading={isJoinLoader}
//                             >Join Now</Button>
//                         </div>
//                     ) : ((onGoingItem?.mode === 'Offline') && (user?.role?.includes('Teacher')) && (onGoingItem?.teacher?.id === user?.id)) ? (
//                         <div>
//                             <Button type='primary' style={{ width: '190px', borderRadius: '8px' }}
//                                 onClick={() => markAttendanceHandler()}
//                                 disabled={isJoinLoader}
//                                 loading={isJoinLoader}
//                             >{onGoingItem?.attendanceMarked ? `${onGoingItem?.attendanceData?.presentCount}/${onGoingItem?.attendanceData?.studentCount}` : 'MARK ATTENDANCE'}</Button>
//                         </div>
//                     ) : (onGoingItem?.mode === 'Others' && onGoingItem?.sUrl) ? (
//                         <div>
//                             <Button type='primary' style={{ width: '190px', borderRadius: '8px' }}
//                                 onClick={() => playStream()}
//                                 loading={isJoinLoader}
//                                 disabled={isJoinLoader}
//                             >Play Stream</Button>
//                         </div>
//                     ) : null}
//                 </div>
//                 {embedModalVisible ? <EmbedModal adding={onGoingItem.sUrl==undefined} embedding={embedding} visible={embedModalVisible} onClose={()=>{setEmbedModalVisible(false)}} onOk={onEmbed}/>:null}
//             </div>
//         )
//     }
//     else if (user?.access?.includes("schedule-student")) {
//         return (
//             <div className="OnGoingClassTandS">
//                 <div style={{ display: 'flex', flexDirection: 'row' }}>
//                     <div className="ongoingclass-img-text">
//                         <div>
//                             <SquareSubIcon icon={onGoingItem?.subject?.icon ? onGoingItem?.subject?.icon : ''} name={onGoingItem?.subject?.name ? onGoingItem?.subject?.name : ''} size={40} />

//                         </div>
//                         <div style={{ marginLeft: '10px', display: 'flex', flexDirection: 'column', width: '200px' }}>
//                             {(onGoingItem.mode == "Zoom 40") ? (
//                                 <div style={{ width: '74px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E7F3FF', borderRadius: '8px', padding: '2px' }}>
//                                     <IoMdVideocam style={{ color: '#1089FF' }} />
//                                     <Text style={{ fontSize: '10px', color: '#1089FF', marginLeft: '5px' }}>Zoom 40</Text>
//                                 </div>
//                                 ) : (onGoingItem.mode == "Broadcast") ? (
//                                     <div style={{ width: '90px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFF4D5', borderRadius: '8px', padding: '2px' }}>
//                                         <img src={Broadcast} style={{ color: '#FFA931', textAlign: 'center', height: "18px", width: "18px" }} />
//                                         <Text style={{ fontSize: '10px', color: '#FFA931', marginLeft: '5px' }}>Broadcast</Text>
//                                     </div>
//                                     ) : (onGoingItem.mode == "Conference") ? (
//                                         <div style={{ width: '77px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#F6F4FE', borderRadius: '8px', padding: '2px' }}>
//                                             <img src={Conference} style={{ color: '#594099', height: "18px", width: "18px" }} />
//                                             <Text style={{ color: '#594099', marginLeft: '5px', fontSize: '10px' }}>Conference</Text>
//                                         </div>
//                                         ) : (onGoingItem.mode == 'Others') ? (
//                                         <div onMouseEnter={() => setHoveringMode(true)} onMouseLeave={() => setHoveringMode(false)}>
//                                             {hoveringMode ? (
//                                                 <Dropdown overlay={
//                                                     <Menu>
//                                                         <Menu.Item key="1" onClick={() => setEmbedModalVisible(true)}>{onGoingItem?.sUrl ? 'Replace link' : 'Add link'}</Menu.Item>
//                                                         {onGoingItem?.sUrl ? <Menu.Item key="2" onClick={() => playStream()}>Play stream</Menu.Item> : null}
//                                                     </Menu>
//                                                 } placement="bottomRight">
//                                                     <MdMoreVert style={{ width: 18, height: 18, color: '#AEAEAE', cursor: 'pointer' }} />
//                                                 </Dropdown>
//                                             ) : (
//                                                 <div style={{ width: 'fit-content', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFE5F4', borderRadius: '8px', padding: '3px 7px' }}>
//                                                     <img src={OtherColor} style={{ color: '#E50087',height:"16px",width:"16px" }} />
//                                                     <Text style={{ color: '#E50087', marginLeft: '5px', fontSize: '10px' }}>Other</Text>
//                                                 </div>
//                                             )}
//                                         </div>
//                                         ) : (
//                                         <div onMouseEnter={() => setHoveringMode(true)} onMouseLeave={() => setHoveringMode(false)}>
//                                             {hoveringMode ? (
//                                                 <Dropdown overlay={
//                                                     <Menu>
//                                                         <Menu.Item key="1" onClick={() => setEmbedModalVisible(true)}>{onGoingItem?.sUrl ? 'Replace link' : 'Add link'}</Menu.Item>
//                                                         {onGoingItem?.sUrl ? <Menu.Item key="2" onClick={() => playStream()}>Play stream</Menu.Item> : null}
//                                                     </Menu>
//                                                 } placement="bottomRight">
//                                                     <MdMoreVert style={{ width: 18, height: 18, color: '#AEAEAE', cursor: 'pointer' }} />
//                                                 </Dropdown>
//                                             ) : (
//                                                 <div style={{ width: '75px', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#E9FCF5', borderRadius: '8px', padding: '2px' }}>
//                                                     <img src={Offline} style={{ color: '#28DF99', textAlign: 'center', height: "18px", width: "18px" }} />
//                                                     <Text style={{ fontSize: '10px', color: '#28DF99', marginLeft: '5px' }}>Offline</Text>
//                                                 </div>
//                                             )}
//                                         </div>
//                             )}
//                             <Tooltip title={onGoingItem?.subject?.name ? onGoingItem?.subject?.name : null}>
//                                 <Text style={{ fontWeight: 'bold', fontSize: '15px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{onGoingItem?.subject?.name}</Text>
//                             </Tooltip>
//                         </div>
//                     </div>
//                 </div>
//                 <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' }}>
//                     <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                         <Avatar shape='circle' size='small' src={`${Api._s3_url}${onGoingItem?.teacher?.image}`} />
//                         <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{onGoingItem?.teacher?.name}</Text>
//                     </div>
//                     <div style={{ width: '50%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
//                         <ClockCircleFilled style={{ fontSize: '11px', color: '#594099' }} />
//                         <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto' }}>{`${moment(onGoingItem?.startTime, 'HH:mm:ss').format("hh:mm A")}-${moment(onGoingItem?.endTime, 'HH:mm:ss').format("hh:mm A")}`}</Text>
//                     </div>
//                 </div>
//                 {(onGoingItem?.mode || '').toLowerCase() === 'broadcast' ? (
//                     <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }} >
//                         <Button type='primary' style={{ width: '190px', borderRadius: '8px' }}
//                             onClick={() => handleJoin()}
//                             loading={isJoinLoader}
//                             disabled={isJoinLoader}
//                         >Join Now</Button>
//                     </div>
//                 ) : (onGoingItem?.mode === 'Others' && onGoingItem?.sUrl) ? (
//                     <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }} >
//                         <Button type='primary' style={{ width: '190px', borderRadius: '8px' }}
//                             onClick={() => playStream()}
//                             loading={isJoinLoader}
//                             disabled={isJoinLoader}
//                         >Play Stream</Button>
//                     </div>
//                 ) : null}

//             </div>
//         )
//     }
// }

// const mapStateToProps = (state) => {
//     const {
//         isJoinLoader
//     } = state.schedule;
//     const { user } = state.session;
//     return {
//         user,
//         isJoinLoader
//     };
// };

// const mapDispatchToProps = (dispatch) => ({
//     setStreamId: (streamId) => dispatch(setStreamId(streamId)),
//     joinClass: (id, callback = null) => dispatch(joinClass(id,callback)),
//     setBroadcastSelectedClassroom: (newClass) => dispatch(setBroadcastSelectedClassroom(newClass)),
//     setJoinLoader: (bool) => dispatch(setJoinLoader(bool)),
//     fetchStudentListData: (id) => dispatch(fetchStudentListData(id)),
//     setSelectedId: (id) => dispatch(setSelectedId(id)),
//     setCardData: (value) => dispatch(setCardData(value)),
//     postEmbedLink: (params, c, sc) => dispatch(postEmbedLink(params, c, sc)),
//     setLiveStreamUrl: (url) => dispatch(setLiveStreamUrl(url))
// });

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps

// )(OnGoingClassTandS);


import React, { useState } from 'react'
import { Dropdown, Typography, Menu, Avatar, Tooltip } from 'antd'
import {
  ClockCircleFilled,
  UserOutlined
} from '@ant-design/icons'
import { MdMoreVert } from 'react-icons/md'
import { FaGraduationCap } from 'react-icons/fa'
import { IoMdVideocam } from 'react-icons/io'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { connect } from 'react-redux'

import { Api, Notification } from 'services'
import { setStreamId, postEmbedLink } from 'actions/broadcast'
import {
  joinClass,
  setBroadcastSelectedClassroom,
  setJoinLoader,
  fetchStudentListData,
  setCardData,
  setSelectedId,
  setLiveStreamUrl
} from 'actions/schedule'
import ScheduleDetailsDrawer from './ScheduleDetailsDrawer'

import { SquareSubIcon } from 'components/subIcon'
import { Button } from 'components/Button'
import { EmbedModal, regexMeet } from './onGoingClassCard'
import { EventRegister } from 'react-native-event-listeners'

import Online from 'Assets/schedule/online.svg'
import Conference from 'Assets/schedule/confrence.svg'
import Offline from 'Assets/schedule/offline.svg'
import OtherColor from 'Assets/schedule/other_color.svg'

const { Text } = Typography

const OnGoingClassTandS = ({
  user,
  onGoingItem,
  setStreamId,
  joinClass,
  setBroadcastSelectedClassroom,
  setJoinLoader,
  isJoinLoader,
  fetchStudentListData,
  setCardData,
  setSelectedId,
  postEmbedLink,
  setLiveStreamUrl,
  currentDate
}) => {
  const history = useHistory()

  const [embedModalVisible, setEmbedModalVisible] = useState(false)
  const [embedding, setEmbedding] = useState(false)
  const [hovered, setHovered] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [detailsOpen, setDetailsOpen] = useState(false)

  useEffect(() => {
    if (
      history.location.state?.scheduleId &&
      (history.location.state?.scheduleId === onGoingItem?.id || history.location.state?.scheduleId === onGoingItem?.scheduleId || history.location.state?.scheduleId === onGoingItem?.occurrenceId) &&
      history.location.state?.activeTab === 'quizzes'
    ) {
      setDetailsOpen(true);
    }
  }, [history.location.state, onGoingItem.id])

  const canPerformAction = user?.privilage?.includes('SuperAdmin') || user?.privilage?.includes('Admin') || user?.privilage?.includes('Planner') || (user?.role?.includes('Teacher') && onGoingItem?.teacher?.id === user?.id);

  const playStream = () => {
    if (onGoingItem?.sUrl?.match(regexMeet)) {
      window.open(onGoingItem.sUrl, '_blank')
    } else {
      setLiveStreamUrl(onGoingItem.sUrl)
      history.push('/liveplayer')
    }
  }

  const onEmbed = async (link) => {
    setEmbedding(true)
    await postEmbedLink({ id: onGoingItem.id, sUrl: link })
    setEmbedding(false)
    setEmbedModalVisible(false)
    EventRegister.emit('apicall:scheduleHome')
  }

  const markAttendanceHandler = () => {
    setSelectedId(onGoingItem.id)
    setCardData(onGoingItem)
    fetchStudentListData(onGoingItem.id)
    // TEMP DIAGNOSTIC — remove once the date-restore-on-back issue is confirmed fixed.
    console.log('[attendance-date-debug] markAttendanceHandler: currentDate prop =', currentDate, 'pathname =', `${history.location.pathname}${history.location.search}`);
    // Carry the selected date back with us so the Back button on
    // /schedule-attendance can return to it explicitly (same relay pattern
    // ScheduleDetailsDrawer.js's goToRecordingsPage uses for Play -> Back) -
    // scheduleAdmin.js otherwise has no way to tell this apart from a fresh
    // visit and resets the filter to today.
    history.push('/schedule-attendance', {
      from: {
        path: `${history.location.pathname}${history.location.search}`,
        state: {
          fromRecordingPlay: true,
          currentDate
        }
      }
    })
  }

  const handleJoin = async () => {
    setJoinLoader(true)
    setCardData(onGoingItem)

    if (onGoingItem?.mode === 'Broadcast') {
      if (onGoingItem?.endTime) {
        const [h, m] = onGoingItem.endTime.split(':').map(Number)
        const endTime = new Date()
        endTime.setHours(h, m, 0)

        if (endTime < new Date()) {
          Notification.error('Error', 'Class end time has passed')
          setJoinLoader(false)
          return
        }
      }

      setStreamId(onGoingItem.roomName || '1234')
      setBroadcastSelectedClassroom(onGoingItem)
      try {
        await joinClass(onGoingItem.id, () => setJoinLoader(false))
      } catch (error) {
        // Refused — see onGoingClassCard. The snackbar is already up; do not navigate.
        setJoinLoader(false)
        return
      }
      history.push('/broadcast')
      return
    }

    setJoinLoader(false)
    Notification.error('Error', 'This mode is not supported on web')
  }

  const menu = (
    <Menu style={{ width: 200, borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
      <Menu.Item key="1" onClick={({ domEvent }) => { domEvent && domEvent.stopPropagation(); setEmbedModalVisible(true); }}>
        {onGoingItem.sUrl ? 'Replace link' : 'Add link'}
      </Menu.Item>

      {onGoingItem.sUrl && (
        <Menu.Item key="2" onClick={({ domEvent }) => { domEvent && domEvent.stopPropagation(); playStream(); }}>
          Play stream
        </Menu.Item>
      )}
    </Menu>
  )

  /* -------------------- TEACHER VIEW -------------------- */

  if (user.access.includes('schedule-teacher')) {
    return (
      <div className="OnGoingClassTandS" onMouseEnter={() => setHovered(true)} onMouseLeave={() => setHovered(false)}>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex' }}>
            <SquareSubIcon
              icon={onGoingItem?.subject?.icon}
              name={onGoingItem?.subject?.name}
              size={40}
            />

            <div style={{ marginLeft: 10, width: 200 }}>
              {onGoingItem.mode === 'Broadcast' && (
                <ModeBadge icon={Online} color="#00A566" bg="#E9FFF9" border="#C8EEE4" text="Online" />
              )}
              {onGoingItem.mode === 'Conference' && (
                <ModeBadge icon={Conference} color="#594099" text="Conference" />
              )}
              {onGoingItem.mode === 'Others' || onGoingItem.mode === 'Other' ? (
                <div
                  style={{ display: 'inline-flex', alignItems: 'center' }}
                >
                  {/* Always show the Others pill */}
                  <ModeBadge icon={OtherColor} color="#E50087" text="Others" />

                  {/* three-dots Add/Replace link for Others — commented out
                  {(!(canPerformAction && (hovered || menuOpen))) && (
                    <ModeBadge icon={OtherColor} color="#E50087" text="Others" />
                  )}

                  {canPerformAction && (
                    <Dropdown
                      overlay={menu}
                      trigger={['hover']}
                      placement="bottomRight"
                      onVisibleChange={(v) => {
                        setMenuOpen(v)
                      }}
                    >
                      <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '4px', opacity: hovered || menuOpen ? 1 : 0, transition: 'opacity 0.12s' }}>
                        <MdMoreVert
                          onClick={(e) => e.stopPropagation()}
                          style={{
                            fontSize: 18,
                            color: '#AEAEAE'
                          }}
                        />
                      </div>
                    </Dropdown>
                  )}
                  */}
                </div>
              ) : onGoingItem.mode === 'Offline' ? (
                <ModeBadge icon={Offline} color="#FF414D" bg="#FFD8DA" border="#FFF5F6" text="Offline" />
              ) : null}

              <Tooltip title={onGoingItem?.subject?.name}>
                <Text strong>{onGoingItem?.subject?.name}</Text>
              </Tooltip>
            </div>
          </div>


        </div>

        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', margin: '10px 0', padding: '0 10px' }}>
          <div style={{ width: '50%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'flex', alignItems: 'center' }}>
            <FaGraduationCap style={{ color: 'purple', marginRight: '5px', flexShrink: 0 }} />
            {onGoingItem?.standards && onGoingItem.standards.length > 0 ? (
              <Text style={{ fontSize: '80%', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {`${onGoingItem.standards[0].std}-${onGoingItem.standards[0].section}`}
                {onGoingItem.standards.length > 1 && (
                  <Tooltip
                    title={onGoingItem.standards.map(item => `${item.std}-${item.section}`).join(', ')}
                    placement="bottom"
                    getPopupContainer={(trigger) => trigger.parentElement}
                  >
                    <span
                      style={{ color: "#594099", fontWeight: 600, cursor: "pointer", marginLeft: 4 }}
                      onClick={(e) => e.stopPropagation()}
                    >
                      + {onGoingItem.standards.length - 1} more
                    </span>
                  </Tooltip>
                )}
              </Text>
            ) : null}
          </div>
          <div style={{ width: '50%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center' }}>
            <ClockCircleFilled style={{ fontSize: '11px', color: '#594099' }} />
            <Text style={{ marginLeft: '5px', color: '#636363', fontSize: '10px', fontFamily: 'roboto', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
              {moment(onGoingItem.startTime, 'HH:mm:ss').format('hh:mm A')} - {moment(onGoingItem.endTime, 'HH:mm:ss').format('hh:mm A')}
            </Text>
          </div>
        </div>

        {
          onGoingItem.mode === 'Broadcast' && (
            <Button
              type="primary"
              style={{ width: 190 }}
              onClick={handleJoin}
              loading={isJoinLoader}
            >
              Join Now
            </Button>
          )
        }

        {
          onGoingItem.mode !== 'Broadcast' && canPerformAction && (
            <Button
              type="link"
              style={{ fontWeight: 600, color: "#594099", paddingRight: 0 }}
              onClick={markAttendanceHandler}
            >
              {onGoingItem?.attendanceMarked ? 'EDIT ATTENDANCE' : 'MARK ATTENDANCE'}
            </Button>
          )
        }

        {
          onGoingItem.mode === 'Others' && onGoingItem.sUrl && (
            <Button
              type="primary"
              style={{ width: 190 }}
              onClick={playStream}
            >
              Play Stream
            </Button>
          )
        }

        {
          embedModalVisible && (
            <EmbedModal
              adding={!onGoingItem.sUrl}
              embedding={embedding}
              visible={embedModalVisible}
              onClose={() => setEmbedModalVisible(false)}
              onOk={onEmbed}
            />
          )
        }

        <ScheduleDetailsDrawer
          open={detailsOpen}
          onClose={() => setDetailsOpen(false)}
          schedule={onGoingItem}
        />
      </div >
    )
  }

  /* -------------------- STUDENT VIEW -------------------- */

  if (user.access.includes('schedule-student')) {
    return (
      <div className="OnGoingClassTandS">
        <SquareSubIcon
          icon={onGoingItem?.subject?.icon}
          name={onGoingItem?.subject?.name}
          size={40}
        />

        <Text strong>{onGoingItem?.subject?.name}</Text>

        <Avatar
          size="small"
          src={`${Api._s3_url}${onGoingItem?.teacher?.image}`}
          icon={<UserOutlined />}
        />

        <Text>{onGoingItem?.teacher?.name}</Text>

        {onGoingItem.mode === 'Broadcast' && (
          <Button
            type="primary"
            onClick={handleJoin}
            loading={isJoinLoader}
          >
            Join Now
          </Button>
        )}

        {onGoingItem.mode === 'Others' && onGoingItem.sUrl && (
          <Button type="primary" onClick={playStream}>
            Play Stream
          </Button>
        )}
      </div>
    )
  }

  return null
}

/* -------------------- MODE BADGE -------------------- */

const ModeBadge = ({ icon, color, text, bg, border }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      background: bg || `${color}22`,
      border: border ? `1px solid ${border}` : 'none',
      borderRadius: 8,
      padding: '2px 6px',
      width: 'fit-content'
    }}
  >
    <img src={icon} alt="" style={{ width: 16, height: 16 }} />
    <Text style={{ color, fontSize: 10, marginLeft: 6 }}>{text}</Text>
  </div>
)

/* -------------------- REDUX -------------------- */

const mapStateToProps = (state) => ({
  user: state.session.user,
  isJoinLoader: state.schedule.isJoinLoader,
  currentDate: state.schedule?.currentDate
})

const mapDispatchToProps = (dispatch) => ({
  setStreamId: (id) => dispatch(setStreamId(id)),
  joinClass: (id, cb) => dispatch(joinClass(id, cb)),
  setBroadcastSelectedClassroom: (c) => dispatch(setBroadcastSelectedClassroom(c)),
  setJoinLoader: (b) => dispatch(setJoinLoader(b)),
  fetchStudentListData: (id) => dispatch(fetchStudentListData(id)),
  setSelectedId: (id) => dispatch(setSelectedId(id)),
  setCardData: (v) => dispatch(setCardData(v)),
  postEmbedLink: (p) => dispatch(postEmbedLink(p)),
  setLiveStreamUrl: (u) => dispatch(setLiveStreamUrl(u))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OnGoingClassTandS)
